import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PlayerService } from '../../services/player.service';
import { GroupService } from '../../services/group.service';
import { Router } from '../../../../node_modules/@angular/router';
import { Player } from '../../objects/player';
import { Group } from '../../objects/group';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { timeout } from '../../../../node_modules/rxjs/operators';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 's18-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private playerService: PlayerService,
    private localStorageService: LocalStorageService,
    private router: Router

  ) { }

  ngOnInit() {
    this.showLoginDialog();
  }

  showLoginDialog() {
    let dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '500px',
      data: { waitForCredentials: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var player = this.getPlayer();
        var forward_url: string = this.localStorageService.get("forward_url");
        // in your authentication promise handler or callback


        if (forward_url) {
          this.localStorageService.set("forward_url", null);
          this.router.navigateByUrl(forward_url);
        }
        else {
          this.router.navigateByUrl("/dashboard");
        }
      }
    });
  }

  getPlayer(): Player {
    return this.playerService.getLoggedInPlayerInfo();
  }

}
